import moment from "moment";
import "moment-timezone";
import { getUserTimezone } from "../utils/timezone";

const initialState = {
  //start date, midnight today in the user's configured timezone (unix timestamp)
  startDate: moment.tz(getUserTimezone()).startOf("day").unix(),
  //end date, end of today in the user's configured timezone (unix timestamp)
  endDate: moment.tz(getUserTimezone()).endOf("day").unix(),
};

//snackbar open reducer
export default function dateRangeReducer(state = initialState, action) {
  switch (action.type) {
    case "dateRange/update":
      return {
        ...state,
        startDate: action.payload.startDate,
        endDate: action.payload.endDate,
      };

    default:
      return state;
  }
}
